import React from 'react'
import { Box } from "@mui/material"

import { AppLinksBlock } from "@components"

export default function actionsColumn() {

	return {
		name: 'name',
		render: (value, { id_report_execution, status}) => <Box sx={{ display: 'flex', justifyContent: 'center' }}>
			<AppLinksBlock
				isRunning={status === 'running'}
				reportExecutionID={id_report_execution}
				downMultiReport={false}
				downMultiExport={false}
				dor={false}
				lor={false}
				position={false}
			/>
		</Box>
	}
}